import React from 'react';
import { Link } from 'react-router-dom';
// Added Github to the imports
import { Mail, MapPin, Linkedin, Instagram, Github, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 text-slate-400 pt-16 pb-8 border-t border-white/5">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Column 1: Brand & Identity */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src={`${process.env.PUBLIC_URL}/images/logo.webp`} 
                alt="EEA Logo" 
                className="h-10 w-auto brightness-200"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-xl font-bold text-white tracking-tight">EEA</span>
                <span className="text-[10px] text-slate-500 uppercase tracking-widest font-bold">IIT Kanpur</span>
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              Empowering the next generation of Electrical Engineers through innovation, 
              collaboration, and hands-on technical excellence at IIT Kanpur.
            </p>
            {/* Updated Social Section with Github */}
            <div className="flex gap-5">
              <a 
                target="_blank" 
                rel="noopener noreferrer"
                href="https://github.com/electricalengineersiitk" 
                className="hover:text-white transition-colors"
                title="GitHub"
              >
                <Github size={20} />
              </a>
              <a 
                target="_blank" 
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/eea-iitk/posts/?feedView=all" 
                className="hover:text-blue-500 transition-colors"
                title="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                target="_blank" 
                rel="noopener noreferrer"
                href="https://www.instagram.com/eea_iitk/?hl=en" 
                className="hover:text-pink-500 transition-colors"
                title="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Navigation */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Navigation</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/" className="hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/research" className="hover:text-blue-400 transition-colors">Research</Link></li>
              <li><Link to="/projects" className="hover:text-blue-400 transition-colors">Projects</Link></li>
              <li><Link to="/blogs" className="hover:text-blue-400 transition-colors">EEA Chronicles</Link></li>
            </ul>
          </div>

          {/* Column 3: Community */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Community</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/team/ug" className="hover:text-blue-400 transition-colors">Undergraduate Team</Link></li>
              <li><Link to="/team/pg" className="hover:text-blue-400 transition-colors">Postgraduate Team</Link></li>
              <li><a href={`${process.env.PUBLIC_URL}/join_eea.pdf`} target="_blank" className="hover:text-blue-400 transition-colors">Join the Association</a></li>
              <li><a href={`${process.env.PUBLIC_URL}/academic_faq.pdf`} target="_blank" className="hover:text-blue-400 transition-colors">Academic FAQs</a></li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div className="space-y-4">
            <h4 className="text-white font-bold mb-6 uppercase text-xs tracking-widest">Reach Us</h4>
            <div className="flex items-start gap-3 text-sm">
              <MapPin size={18} className="text-blue-500 shrink-0" />
              <p>ACES 216, Dept. of Electrical Engineering, IIT Kanpur, UP 208016</p>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Mail size={18} className="text-blue-500 shrink-0" />
              <a href="mailto:eea@iitk.ac.in" className="hover:text-white transition-colors">eea@iitk.ac.in</a>
            </div>
            <button 
              onClick={scrollToTop}
              className="mt-4 flex items-center gap-2 text-xs font-bold text-slate-500 hover:text-white transition-all uppercase tracking-widest"
            >
              Back to Top <ArrowUp size={14} />
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-bold uppercase tracking-widest">
          <p>© {new Date().getFullYear()} EEA IIT KANPUR. ALL RIGHTS RESERVED.</p>
          <div className="flex gap-6">
            <span className="text-slate-600">Designed with Passion by EEA Web Team</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;